
import { defineComponent, PropType } from 'vue';
import { useProcessAvatar } from '@/composables';
import { CardUserItem } from './types';

export default defineComponent({
  props: {
    /** 课程数据项 */
    user: { type: Object as PropType<CardUserItem>, required: true },
  },
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
});
